export default __webpack_public_path__ + "static/media/carrier-global_Showcase1.png";